import type { ITemplateConfigOptions } from '~/types/template'

import {
  fullEmbeddedTemplates,
  onBoardingLandscapeTemplates,
  onBoardingPortraitTemplates,
  storeLandscapeTemplates,
  storePortraitTemplates,
  pickerPortraitTemplates,
} from '~/const/template-config'

export const getTemplateFromKey = (templateKey: string): ITemplateConfigOptions | undefined =>
  getTemplateConfigs().find(({ key }) => templateKey === key)

export const formatTemplateFilterName = (filter: string): string =>
  ({
    eligible: 'Eligible',
    not_eligible: 'Not Eligible',
  })[filter] || filter

export const getTemplateConfigs = (): ITemplateConfigOptions[] =>
  [
    ...Object.values(onBoardingPortraitTemplates),
    ...Object.values(onBoardingLandscapeTemplates),
    ...Object.values(storePortraitTemplates),
    ...Object.values(storeLandscapeTemplates),
    ...Object.values(pickerPortraitTemplates),
    ...Object.values(fullEmbeddedTemplates),
  ].reduce((prev, { keys, ...templateConfig }) => {
    keys.forEach((key) => {
      prev.push({ key, ...templateConfig })
    })
    return prev
  }, [] as ITemplateConfigOptions[])
